import type { ComparisonConfig } from './ComparisonPage';

const OPERA_HI: ComparisonConfig = {
  slug: 'hotelstack-vs-opera',
  competitorName: 'Oracle OPERA',
  heroTitle: 'HotelStack.io बनाम Oracle OPERA',
  heroSubtitle: 'Oracle OPERA दशकों पुराना उद्योग मानक है — जो एंटरप्राइज़-युग की जटिलता और मूल्य निर्धारण के साथ बना है। HotelStack.io अधिक मॉड्यूल, सरल मूल्य निर्धारण और शून्य इंफ्रास्ट्रक्चर ओवरहेड के साथ एक आधुनिक, क्लाउड-नेटिव विकल्प प्रदान करता है।',
  overviewComparison: [
    { label: 'आर्किटेक्चर', hotelstack: 'क्लाउड-नेटिव SaaS', competitor: 'लेगेसी ऑन-प्रिमाइस / क्लाउड' },
    { label: 'मूल्य निर्धारण', hotelstack: '$49/माह से', competitor: '$500+/माह + लाइसेंस' },
    { label: 'कार्यान्वयन', hotelstack: 'निःशुल्क — 48 घंटे ऑनबोर्डिंग', competitor: '3-6 महीने कार्यान्वयन' },
    { label: 'कुल मॉड्यूल', hotelstack: '36 बिल्ट-इन', competitor: '20+ (अलग लाइसेंस)' },
    { label: 'खाद्य एवं पेय / POS', hotelstack: 'बिल्ट-इन', competitor: 'अलग OPERA POS लाइसेंस' },
    { label: 'लक्ष्य सेगमेंट', hotelstack: 'SMB से एंटरप्राइज़', competitor: 'केवल एंटरप्राइज़' },
  ],
  featureTable: [
    {
      category: 'कोर PMS',
      features: [
        { name: 'आरक्षण प्रबंधन', hotelstack: true, competitor: true },
        { name: 'विज़ुअल रूम बोर्ड', hotelstack: true, competitor: true },
        { name: 'नाइट ऑडिट विज़ार्ड', hotelstack: true, competitor: true },
        { name: 'गेस्ट फोलियो प्रबंधन', hotelstack: true, competitor: true },
        { name: 'ग्रुप बुकिंग', hotelstack: true, competitor: true },
        { name: 'ऑनलाइन चेक-इन पोर्टल', hotelstack: true, competitor: 'ऐड-ऑन' },
      ],
    },
    {
      category: 'क्लाउड और एक्सेसिबिलिटी',
      features: [
        { name: 'ट्रू क्लाउड-नेटिव', hotelstack: true, competitor: 'हाइब्रिड' },
        { name: 'शून्य सर्वर रखरखाव', hotelstack: true, competitor: false },
        { name: 'रीयल-टाइम मल्टी-डिवाइस सिंक', hotelstack: true, competitor: 'सीमित' },
        { name: 'आधुनिक रेस्पॉन्सिव UI', hotelstack: true, competitor: false },
        { name: 'स्वचालित अपडेट', hotelstack: true, competitor: false },
        { name: 'IT स्टाफ की आवश्यकता नहीं', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'राजस्व प्रबंधन',
      features: [
        { name: 'डायनामिक प्राइसिंग नियम', hotelstack: true, competitor: true },
        { name: 'व्हाट-इफ रेवेन्यू सिम्युलेटर', hotelstack: true, competitor: false },
        { name: 'प्रतिस्पर्धी दर मॉनिटर', hotelstack: true, competitor: 'Oracle BI द्वारा' },
        { name: 'मांग पूर्वानुमान', hotelstack: true, competitor: true },
        { name: 'RevPAR एनालिटिक्स', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'खाद्य एवं पेय और संचालन',
      features: [
        { name: 'POS टर्मिनल', hotelstack: true, competitor: 'अलग लाइसेंस' },
        { name: 'रूम सर्विस मॉड्यूल', hotelstack: true, competitor: 'अलग लाइसेंस' },
        { name: 'किचन डिस्प्ले सिस्टम', hotelstack: true, competitor: false },
        { name: 'स्टाफ शेड्यूलिंग', hotelstack: true, competitor: false },
        { name: 'रखरखाव कार्य आदेश', hotelstack: true, competitor: 'एकीकरण द्वारा' },
      ],
    },
    {
      category: 'लागत और ऑनबोर्डिंग',
      features: [
        { name: 'निःशुल्क ऑनबोर्डिंग', hotelstack: true, competitor: false },
        { name: 'निःशुल्क डेटा माइग्रेशन', hotelstack: true, competitor: false },
        { name: 'कोई सर्वर लागत नहीं', hotelstack: true, competitor: false },
        { name: 'कोई लाइसेंस शुल्क नहीं', hotelstack: true, competitor: false },
        { name: 'क्षेत्रीय मुद्रा मूल्य', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'लचीलापन और ऑफ़लाइन',
      features: [
        { name: 'ऑफ़लाइन-सक्षम PWA', hotelstack: true, competitor: false },
        { name: 'ऑफ़लाइन परिवर्तन कतार', hotelstack: true, competitor: false },
        { name: 'पुनः कनेक्ट होने पर बैकग्राउंड सिंक', hotelstack: true, competitor: false },
        { name: 'विरोध-सचेत समाधान', hotelstack: true, competitor: false },
        { name: 'इंस्टॉल करने योग्य फ्रंट डेस्क', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'कॉर्पोरेट और समूह बिक्री',
      features: [
        { name: 'कॉर्पोरेट दर प्रबंधन', hotelstack: true, competitor: 'ऐड-ऑन' },
        { name: 'रूमिंग लिस्ट के साथ समूह बुकिंग', hotelstack: true, competitor: 'ऐड-ऑन' },
        { name: 'प्राप्य आयु और उत्पादन रिपोर्ट', hotelstack: true, competitor: 'ऐड-ऑन' },
        { name: 'रेस्तरां आरक्षण', hotelstack: true, competitor: 'Micros ऐड-ऑन' },
      ],
    },
    {
      category: 'स्टाफ और मानव संसाधन',
      features: [
        { name: 'स्टाफ निर्देशिका और शेड्यूलिंग', hotelstack: true, competitor: 'एकीकरण द्वारा' },
        { name: 'पेरोल प्रोसेसिंग', hotelstack: true, competitor: false },
        { name: 'अवकाश और उपस्थिति', hotelstack: true, competitor: false },
        { name: 'प्रदर्शन विश्लेषण', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$500+',
    hotelstackNote: 'सभी 36 मॉड्यूल शामिल। कोई लाइसेंस शुल्क नहीं। कोई सर्वर लागत नहीं। निःशुल्क ऑनबोर्डिंग और माइग्रेशन। EUR, GBP, AED, INR, THB में क्षेत्रीय मूल्य।',
    competitorNote: 'प्रति संपत्ति $500+/माह से एंटरप्राइज़ लाइसेंसिंग। अलग POS, S&C और OCRM लाइसेंस। $50,000+ से कार्यान्वयन शुल्क। क्लासिक संस्करण के लिए ऑन-प्रिमाइस सर्वर आवश्यक।',
  },
  advantages: [
    '90% से अधिक कम कुल स्वामित्व लागत — कोई लाइसेंस शुल्क, सर्वर लागत या कार्यान्वयन शुल्क नहीं',
    'OPERA के 3-6 महीने कार्यान्वयन के मुकाबले 48 घंटों में लाइव',
    'किसी भी डिवाइस से एक्सेसिबल आधुनिक क्लाउड-नेटिव UI — कोई डेस्कटॉप क्लाइंट आवश्यक नहीं',
    'अलग OPERA मॉड्यूल लाइसेंस के मुकाबले एक सब्सक्रिप्शन में सभी 36 मॉड्यूल शामिल',
    'शून्य IT इंफ्रास्ट्रक्चर — कोई सर्वर नहीं, कोई पैच नहीं, कोई Oracle DBA आवश्यक नहीं',
    'अलग OPERA POS लाइसेंसिंग के मुकाबले बिना अतिरिक्त लागत के बिल्ट-इन खाद्य एवं पेय और POS',
    '6 मुद्राओं में क्षेत्रीय मूल्य ताकि होटल स्थानीय मुद्रा में भुगतान करें',
    'समर्पित सहायता टीम के साथ OPERA से निःशुल्क डेटा माइग्रेशन',
  ],
  verdict: {
    title: 'हमारा निर्णय',
    summary: 'Oracle OPERA दशकों से उद्योग मानक रहा है और मौजूदा Oracle इंफ्रास्ट्रक्चर वाली बड़ी एंटरप्राइज़ चेन के लिए एक ठोस विकल्प बना हुआ है। हालांकि, अधिकांश होटलों के लिए, HotelStack.io अधिक मॉड्यूल, बेहतर UX और नाटकीय रूप से कम लागत प्रदान करता है — बिना बहु-माह कार्यान्वयन चक्र, सर्वर ओवरहेड और जटिल लाइसेंसिंग के जो OPERA मांगता है।',
    bestFor: [
      'महंगी Oracle लाइसेंसिंग और इंफ्रास्ट्रक्चर लागत समाप्त करने वाले होटल',
      'धीमे OPERA कार्यान्वयन और अपग्रेड चक्रों से थकी संपत्तियां',
      'डेस्कटॉप क्लाइंट निर्भरता के बिना आधुनिक क्लाउड-नेटिव UI चाहने वाले होटल',
      'OPERA एंटरप्राइज़ प्लान से बाहर कीमत वाली SMB और मिड-स्केल संपत्तियां',
      'अलग लाइसेंस शुल्क के बिना सभी मॉड्यूल शामिल चाहने वाली संपत्तियां',
    ],
  },
  faqItems: [
    { question: 'क्या मैं Oracle OPERA से HotelStack.io पर माइग्रेट कर सकता हूं?', answer: 'हां। हमारी माइग्रेशन टीम OPERA-से-HotelStack ट्रांज़िशन में विशेषज्ञ है। हम अतिथि प्रोफाइल, आरक्षण इतिहास, दर कोड, कमरे के कॉन्फिगरेशन और ग्रुप ब्लॉक आयात करते हैं। माइग्रेशन निःशुल्क है और आमतौर पर शून्य डाउनटाइम के साथ 48-72 घंटों में पूरा होता है।' },
    { question: 'क्या HotelStack.io OPERA के समान एकीकरण सपोर्ट करता है?', answer: 'HotelStack.io 100+ OTA, Amadeus और Sabre के माध्यम से GDS और प्रमुख भुगतान गेटवे से जुड़ता है। हमारा एकीकरण मार्केटप्लेस समान इकोसिस्टम कवर करता है। हम कस्टम एकीकरण के लिए ओपन API भी प्रदान करते हैं।' },
    { question: 'HotelStack.io, OPERA Cloud से कैसे तुलना करता है?', answer: 'OPERA Cloud, Oracle द्वारा अपने लेगेसी उत्पाद का आधुनिकीकरण है। HotelStack.io पहले दिन से आधुनिक टेक स्टैक के साथ क्लाउड-नेटिव बनाया गया था। हम अधिक मॉड्यूल (36 बनाम OPERA Cloud बेस), सरल मूल्य, तेज ऑनबोर्डिंग और कोई Oracle इंफ्रास्ट्रक्चर निर्भरता प्रदान करते हैं।' },
    { question: 'क्या HotelStack.io वर्तमान में OPERA पर बड़ी होटल चेन के लिए उपयुक्त है?', answer: 'हां। हमारे Chain और Enterprise प्लान केंद्रीकृत एनालिटिक्स, दर वितरण और ब्रांड मानकों के साथ मल्टी-प्रॉपर्टी प्रबंधन का समर्थन करते हैं — वही क्षमताएं जो बड़ी चेन को OPERA पर रखती हैं, लागत के एक अंश पर।' },
  ],
};

const RMS_CLOUD_HI: ComparisonConfig = {
  slug: 'hotelstack-vs-rms-cloud',
  competitorName: 'RMS Cloud',
  heroTitle: 'HotelStack.io बनाम RMS Cloud',
  heroSubtitle: 'RMS Cloud APAC हॉस्पिटैलिटी बाजार में मजबूत PMS बुनियादी बातों के साथ सेवा करता है। HotelStack.io 36 मॉड्यूल, वैश्विक बहु-मुद्रा मूल्य, बिल्ट-इन खाद्य एवं पेय/POS और उन्नत राजस्व प्रबंधन के साथ इसे विस्तारित करता है — सभी कम कीमत पर।',
  overviewComparison: [
    { label: 'कुल मॉड्यूल', hotelstack: '36 एकीकृत मॉड्यूल', competitor: '12+ मॉड्यूल' },
    { label: 'मूल्य निर्धारण', hotelstack: '$49/माह से', competitor: '$80+/माह से' },
    { label: 'वैश्विक पहुंच', hotelstack: '40+ देश', competitor: 'मुख्य रूप से APAC' },
    { label: 'खाद्य एवं पेय / POS', hotelstack: 'बिल्ट-इन', competitor: 'उपलब्ध नहीं' },
    { label: 'राजस्व प्रबंधन', hotelstack: 'उन्नत (बिल्ट-इन)', competitor: 'बुनियादी' },
    { label: 'बुकिंग इंजन', hotelstack: 'BookMyRoom.io (निःशुल्क)', competitor: 'बुनियादी विजेट' },
  ],
  featureTable: [
    {
      category: 'कोर PMS',
      features: [
        { name: 'क्लाउड-बेस्ड PMS', hotelstack: true, competitor: true },
        { name: 'विज़ुअल रूम बोर्ड', hotelstack: true, competitor: true },
        { name: 'आरक्षण प्रबंधन', hotelstack: true, competitor: true },
        { name: 'नाइट ऑडिट विज़ार्ड', hotelstack: true, competitor: true },
        { name: 'ग्रुप बुकिंग', hotelstack: true, competitor: true },
        { name: 'ऑनलाइन चेक-इन पोर्टल', hotelstack: true, competitor: 'सीमित' },
      ],
    },
    {
      category: 'राजस्व और वितरण',
      features: [
        { name: 'चैनल मैनेजर (100+ OTA)', hotelstack: true, competitor: 'सीमित OTA' },
        { name: 'डायनामिक प्राइसिंग नियम', hotelstack: true, competitor: false },
        { name: 'प्रतिस्पर्धी दर मॉनिटर', hotelstack: true, competitor: false },
        { name: 'व्हाट-इफ रेवेन्यू सिम्युलेटर', hotelstack: true, competitor: false },
        { name: 'मांग पूर्वानुमान', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'RevPAR एनालिटिक्स', hotelstack: true, competitor: 'बुनियादी' },
      ],
    },
    {
      category: 'अतिथि प्रबंधन',
      features: [
        { name: '360-डिग्री अतिथि प्रोफाइल', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'लॉयल्टी प्रोग्राम प्रबंधन', hotelstack: true, competitor: false },
        { name: 'अतिथि संचार ऑटोमेशन', hotelstack: true, competitor: 'सीमित' },
        { name: 'अतिथि खर्च एनालिटिक्स', hotelstack: true, competitor: false },
        { name: 'आईडी अपलोड और सत्यापन', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'खाद्य एवं पेय और संचालन',
      features: [
        { name: 'POS टर्मिनल', hotelstack: true, competitor: false },
        { name: 'रूम सर्विस मॉड्यूल', hotelstack: true, competitor: false },
        { name: 'किचन डिस्प्ले सिस्टम', hotelstack: true, competitor: false },
        { name: 'हाउसकीपिंग प्रबंधन', hotelstack: true, competitor: true },
        { name: 'रखरखाव कार्य आदेश', hotelstack: true, competitor: false },
        { name: 'स्टाफ शेड्यूलिंग और पेरोल', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'मल्टी-प्रॉपर्टी और अनुपालन',
      features: [
        { name: 'चेन डैशबोर्ड', hotelstack: true, competitor: true },
        { name: 'क्रॉस-प्रॉपर्टी एनालिटिक्स', hotelstack: true, competitor: 'सीमित' },
        { name: 'बहु-मुद्रा बिलिंग', hotelstack: true, competitor: 'AUD केंद्रित' },
        { name: 'क्षेत्रीय कर अनुपालन', hotelstack: true, competitor: 'केवल APAC' },
        { name: 'GDPR डेटा सुरक्षा', hotelstack: true, competitor: 'सीमित' },
      ],
    },
    {
      category: 'लचीलापन और ऑफ़लाइन',
      features: [
        { name: 'ऑफ़लाइन-सक्षम PWA', hotelstack: true, competitor: false },
        { name: 'ऑफ़लाइन परिवर्तन कतार', hotelstack: true, competitor: false },
        { name: 'पुनः कनेक्ट होने पर बैकग्राउंड सिंक', hotelstack: true, competitor: false },
        { name: 'विरोध-सचेत समाधान', hotelstack: true, competitor: false },
        { name: 'इंस्टॉल करने योग्य फ्रंट डेस्क', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'कॉर्पोरेट और समूह बिक्री',
      features: [
        { name: 'कॉर्पोरेट दर प्रबंधन', hotelstack: true, competitor: false },
        { name: 'रूमिंग लिस्ट के साथ समूह बुकिंग', hotelstack: true, competitor: 'सीमित' },
        { name: 'प्राप्य आयु और उत्पादन रिपोर्ट', hotelstack: true, competitor: false },
        { name: 'रेस्तरां आरक्षण', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'स्टाफ और मानव संसाधन',
      features: [
        { name: 'स्टाफ निर्देशिका और शेड्यूलिंग', hotelstack: true, competitor: false },
        { name: 'पेरोल प्रोसेसिंग', hotelstack: true, competitor: false },
        { name: 'अवकाश और उपस्थिति', hotelstack: true, competitor: false },
        { name: 'प्रदर्शन विश्लेषण', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$80+',
    hotelstackNote: 'सभी 36 मॉड्यूल शामिल। EUR, GBP, AED, INR, THB में क्षेत्रीय मूल्य। निःशुल्क ऑनबोर्डिंग और डेटा माइग्रेशन।',
    competitorNote: '$80+/माह से AUD-आधारित मूल्य। चैनल मैनेजर और प्रीमियम सुविधाओं के लिए अतिरिक्त शुल्क। मुख्य रूप से APAC सहायता।',
  },
  advantages: [
    'कम कीमत पर लगभग तीन गुना मॉड्यूल (36 बनाम 12+) सभी सुविधाएं शामिल',
    'RMS Cloud के APAC बाजार फोकस के मुकाबले 40+ देशों में वैश्विक कवरेज',
    'POS टर्मिनल, रूम सर्विस और किचन प्रबंधन के साथ पूर्ण खाद्य एवं पेय मॉड्यूल',
    'डायनामिक प्राइसिंग, पूर्वानुमान और सिम्युलेटर के साथ उन्नत राजस्व प्रबंधन',
    'Amadeus और Sabre के माध्यम से 100+ OTA और GDS के साथ मजबूत चैनल कनेक्टिविटी',
    'शेड्यूलिंग, पेरोल, उपस्थिति और प्रदर्शन ट्रैकिंग के साथ स्टाफ प्रबंधन',
    'मुख्य रूप से AUD-आधारित मूल्य के मुकाबले 6 मुद्राओं में बहु-मुद्रा बिलिंग',
    '24/7 समर्पित सहायता के साथ निःशुल्क ऑनबोर्डिंग और डेटा माइग्रेशन',
  ],
  verdict: {
    title: 'हमारा निर्णय',
    summary: 'RMS Cloud आवास प्रबंधन के लिए मजबूत बुनियादी बातों के साथ APAC संपत्तियों के लिए एक सक्षम PMS है। HotelStack.io 36 मॉड्यूल, वैश्विक पहुंच, उन्नत राजस्व प्रबंधन और पूर्ण खाद्य एवं पेय/POS क्षमताओं के साथ अधिक व्यापक समाधान प्रदान करता है — सभी कम कीमत पर। बुनियादी PMS से परे पूर्ण होटल संचालन प्रबंधन चाहने वाली संपत्तियों के लिए, HotelStack.io मजबूत विकल्प है।',
    bestFor: [
      'बुनियादी PMS से परे पूर्ण ऑल-इन-वन प्लेटफॉर्म चाहने वाले होटल',
      'बिल्ट-इन खाद्य एवं पेय, POS और किचन प्रबंधन की आवश्यकता वाली संपत्तियां',
      'APAC के बाहर विस्तार करने वाले होटल जिन्हें वैश्विक अनुपालन और वितरण चाहिए',
      'उन्नत राजस्व प्रबंधन और डायनामिक प्राइसिंग चाहने वाली संपत्तियां',
      'वैश्विक संपत्तियों में केंद्रीकृत एनालिटिक्स की आवश्यकता वाली मल्टी-प्रॉपर्टी चेन',
    ],
  },
  faqItems: [
    { question: 'क्या मैं RMS Cloud से HotelStack.io पर माइग्रेट कर सकता हूं?', answer: 'हां। हमारी माइग्रेशन टीम अतिथि प्रोफाइल, आरक्षण इतिहास, दर कॉन्फिगरेशन और कमरे के सेटअप सहित RMS Cloud से पूर्ण डेटा ट्रांसफर संभालती है। माइग्रेशन निःशुल्क है और आमतौर पर शून्य डाउनटाइम के साथ 48 घंटों में पूरा होता है।' },
    { question: 'क्या HotelStack.io ऑस्ट्रेलियाई और APAC होटलों के लिए अच्छा काम करता है?', answer: 'बिल्कुल। HotelStack.io AUD सहित बहु-मुद्रा बिलिंग, APAC बाजारों के लिए क्षेत्रीय कर अनुपालन और APAC-केंद्रित OTA कनेक्शन का समर्थन करता है। हमारी कई APAC संपत्तियों ने अतिरिक्त मॉड्यूल और वैश्विक पहुंच के लिए RMS Cloud से स्विच किया।' },
    { question: 'HotelStack.io का मूल्य RMS Cloud से कैसे तुलना करता है?', answer: 'HotelStack.io $49/माह से शुरू होता है जिसमें सभी 36 मॉड्यूल और 6 मुद्राओं में क्षेत्रीय मूल्य शामिल है। RMS Cloud लगभग $80+/माह AUD से शुरू होता है जिसमें कम मॉड्यूल और चैनल प्रबंधन व प्रीमियम सुविधाओं के लिए अतिरिक्त शुल्क।' },
    { question: 'क्या HotelStack.io, RMS Cloud की तरह हॉलिडे पार्क और कैम्पग्राउंड सपोर्ट करता है?', answer: 'HotelStack.io सभी आवास प्रकारों के लिए डिज़ाइन किया गया है जिसमें होटल, रिसॉर्ट, हॉस्टल, बुटीक संपत्तियां और सर्विस्ड अपार्टमेंट शामिल हैं। जबकि RMS Cloud में हॉलिडे पार्क के लिए विशिष्ट सुविधाएं हैं, HotelStack.io की संपत्ति कॉन्फिगरेशन लचीलापन विविध आवास मॉडल का समर्थन करता है।' },
  ],
};

export const COMPARISON_HI_P2: Record<string, ComparisonConfig> = {
  'hotelstack-vs-opera': OPERA_HI,
  'hotelstack-vs-rms-cloud': RMS_CLOUD_HI,
};
